@if (message()) {
  <div class="banner"
       [class.caution]="bannerType() === 'caution'"
       [@messageChanged]>
    <div class="message">
      <div class="row"
           id="system-banner-message">

        @if (bannerType() === 'caution') {
          <mat-icon>network_check</mat-icon>
        }
        {{message()}}
      </div>
    </div>
    <div class="banner-actions row">
      <button (click)="dismissBanner()"
              [color]="bannerType() === 'primary' ? 'primary' : 'default'"
              type="button"
              [matButton]="bannerType() === 'primary' ? 'filled' : 'text'">
        Dismiss
      </button>
      @if (bannerType() === 'primary') {
        <a mat-flat-button
           color="primary"
           href="https://ezlynx.statuspage.io/"
           target="_blank"
           rel="noreferrer">
          View EZLynx status
          <mat-icon iconPositionEnd>open_in_new</mat-icon>
        </a>
      }
    </div>
  </div>
}